import { Flex, Skeleton } from 'antd'
import styled from 'styled-components'

export const StyledInputSkeleton = styled(Skeleton.Input)<{
  $width: React.CSSProperties['width']
}>`
  height: 16px;
  width: ${({ $width }) => $width} !important;
  min-width: ${({ $width }) => $width} !important;
  > .ant-skeleton-input {
    height: 16px;
    max-height: 16px;
    width: ${({ $width }) => $width} !important;
    min-width: ${({ $width }) => $width} !important;
  }
`

type Props = {
  width?: React.CSSProperties['width']
}
export const FormSelectLoadingPlaceholder = ({ width = '140px' }: Props) => (
  <Flex vertical justify="center" style={{ width: '100%', paddingRight: '12px' }}>
    <StyledInputSkeleton active $width={width} />
  </Flex>
)
